export default function Youtube({ className }: { className ?: string}) {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="21"
    viewBox="0 0 26 21"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_5337_6601)">
      <path
        d="M22.8005 4.633C22.7099 4.27885 22.4537 4.01164 22.1602 3.92921C21.6389 3.78384 19.1077 3.4502 13.7573 3.4502C8.40698 3.4502 5.87632 3.78397 5.35285 3.92962C5.06216 4.01047 4.80599 4.27763 4.7142 4.633C4.58484 5.13761 4.2456 7.25007 4.2456 10.584C4.2456 13.9179 4.58484 16.0304 4.71456 16.5364C4.80475 16.8892 5.06097 17.1564 5.35316 17.2384C5.87632 17.3841 8.40698 17.7178 13.7573 17.7178C19.1077 17.7178 21.6389 17.3842 22.1618 17.2384C22.4525 17.1576 22.7087 16.8904 22.8005 16.535C22.9298 16.0304 23.269 13.9131 23.269 10.584C23.269 7.25488 22.9298 5.13761 22.8005 4.633ZM25.1039 4.04251C25.647 6.16104 25.647 10.584 25.647 10.584C25.647 10.584 25.647 15.007 25.1039 17.1255C24.8013 18.2972 23.9182 19.218 22.7989 19.5293C20.7676 20.0957 13.7573 20.0957 13.7573 20.0957C13.7573 20.0957 6.75122 20.0957 4.71571 19.5293C3.59224 19.2138 2.70924 18.2928 2.41075 17.1255C1.86768 15.007 1.86768 10.584 1.86768 10.584C1.86768 10.584 1.86768 6.16104 2.41075 4.04251C2.71337 2.87085 3.59639 1.94994 4.71571 1.63864C6.75122 1.07227 13.7573 1.07227 13.7573 1.07227C13.7573 1.07227 20.7676 1.07227 22.7989 1.63864C23.9224 1.95426 24.8054 2.87517 25.1039 4.04251ZM11.3794 14.7454V6.42261L18.5132 10.584L11.3794 14.7454Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5337_6601">
        <rect
          width="25"
          height="20"
          fill="white"
          transform="translate(0.983521 0.605469)"
        />
      </clipPath>
    </defs>
  </svg>;
}
